import { loadState, persistState } from 'common/localStorage';

export function shouldSkipArchiveExperimentHeadConfirmation() {
  return loadState().dontShowArchiveExperimentHeadConfirmation ?? false;
}

export function skipArchiveExperimentHeadConfirmationInFuture() {
  persistState({ dontShowArchiveExperimentHeadConfirmation: true });
}
